<script setup lang="ts">
import InfoTooltip from '@/shared/ui/InfoTooltip/index';

const isShow = defineModel<boolean>({ default: false });

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['rating-tooltip', { _mobile: isMobile }]">
    <InfoTooltip v-model="isShow" :is-show-cross="false" class="rating-tooltip__tooltip">
      <template #tooltip-content>
        <p class="rating-tooltip__text">
          Рейтинг формируется на основании собранной и предоставленной информации. Мы
          учитываем такие данные, как: опыт, образование, судебная практика, публикации.
        </p>
      </template>
    </InfoTooltip>
  </div>
</template>

<style lang="less">
.rating-tooltip {
  position: absolute;
  bottom: 50%;
  left: 50%;
  width: 238px;
  z-index: 990;

  &__tooltip {
    border-radius: @main-size;
    padding: @size-x3;
  }

  &__text {
    font-size: @size-x3;
    line-height: @size-x4;
    font-weight: 600;
  }

  small {
    font-weight: 500;
  }

  &._mobile {
    width: 205px;
  }

  &._mobile &__text {
    font-size: @size-x3;
    line-height: @size-x4;
  }
}
</style>
